<template>
<div>
  <b-form-select v-model="catalog_id"  class="mb-2 mt-3 form-select-lg w-100" @change="$emit('getCatalogId', catalog_id)">
    <template #first>
      <b-form-select-option :value="null" disabled>-- Каталог --</b-form-select-option>
    </template>
    <b-form-select-option style="font-family: 'Roboto Slab'" v-for="item in catalog.data" :key="item.name" :value="item.id" :label="item.name">
      {{item.name}}
    </b-form-select-option>
  </b-form-select>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "InputSelectCatalog",

  data() {
    return {
      catalog_id: null,
    }

  },
  computed: {
    ...mapGetters(['catalog']),

  },
  methods: {
    ...mapActions(['loadCatalogs']),


  }
}
</script>

<style scoped>

</style>